module.exports = __webpack_public_path__ + "img/9_Hills-01.fcf8ef11.png";